export default "__VITE_ASSET__DjgNd83a__"